var map = {
	"./back.svg": "7338",
	"./bank-transfer.svg": "19ca",
	"./cancel.svg": "b463",
	"./card.svg": "5d4a",
	"./cart.svg": "daca",
	"./download.svg": "f28e",
	"./expand-down.svg": "7d94",
	"./expand.svg": "8336",
	"./include.svg": "fe6a",
	"./information.svg": "e923",
	"./logo_onebw.svg": "f11b",
	"./logo_power.svg": "48b0",
	"./logo_standard.svg": "3e71",
	"./logo_start.svg": "ea0a",
	"./paypal.svg": "8a1b",
	"./products/automatic.svg": "2144",
	"./products/bw1mapper.svg": "6bd4",
	"./products/bw1player.svg": "f5f1",
	"./products/bw1studio.svg": "ad51",
	"./products/bwclockserver.svg": "6a5d",
	"./products/urleditor.svg": "8713",
	"./stable.svg": "0f5d",
	"./unstable.svg": "e3fd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";